var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 341.611,
    height: 169.367,
    viewBox: "0 0 341.611 169.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.377,
    x2: 0.5,
    y2: 1.604,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd7c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa5a5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.346,
    y2: 1.521,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbe1ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff73b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff73b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#485295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ad7dfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b62d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdbbda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff73b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1.183,
    y1: 0.838,
    x2: 0.081,
    y2: 0.623,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl",
    transform: "translate(1.217 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M27.716.186H0",
    transform: "translate(139.457 60.209)",
    fill: "none",
    stroke: "#ff75b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.434
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M27.716.186H0",
    transform: "translate(145.329 48.432)",
    fill: "none",
    stroke: "#ff75b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.434
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M13.037.186H0",
    transform: "translate(118.906 60.209)",
    fill: "none",
    stroke: "#ff75b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.434
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M27.716.186H0",
    transform: "translate(98.354 86.707)",
    fill: "none",
    stroke: "#ff75b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.434
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M27.716.186H0",
    transform: "translate(63.123 86.707)",
    fill: "none",
    stroke: "#ff75b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.434
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M30.652.186H0",
    transform: "translate(66.94 105.256)",
    fill: "none",
    stroke: "#ff75b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.434
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M4.229.186H0",
    transform: "translate(55.196 105.256)",
    fill: "none",
    stroke: "#ff75b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.434
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M57.076.186H0",
    transform: "translate(0 131.755)",
    fill: "none",
    stroke: "#ff75b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.434
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    d: "M13.037.186H0",
    transform: "translate(67.527 131.755)",
    fill: "none",
    stroke: "#ff75b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.434
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    d: "M63.235,17.659c1.88.575,1.859-9.058-2.893-12.34C57.174,3.131,50.63-1.3,40.71,3.812A4.192,4.192,0,0,0,36.74.027c-3.4-.421-14.279,4.122-9.874,6.187a14.327,14.327,0,0,0,10.153.475c-6.187,6.432-12.006,0-15.312,1.1-4.959,1.647-8.883-.548-11.724,2.1a9.407,9.407,0,0,0-2.908,7.071c-4.155-.365-13.6,10.528,0,17.175s22.764,7.816,26.816,3.153c2.7-3.109,1.633-3.905,1.633-3.905s7.645.8,7.6-1.569,12.376,1.059,10.67-1.1Q61.355,17.084,63.235,17.659Z",
    transform: "translate(142.065 0)",
    fill: "#423565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    "data-name": "Shape",
    d: "M30.832,7.442Q23.346-3,21.7,1.209T12.282,11.682Q3.335,9.16.307,10.182C-2.721,11.2,17.363,59.434,29.384,50.965s8.912-13.457,5.7-18.6-1.211-9.781-3.017-12.679-9.327-1.35-7.015-6.85Q27.368,7.331,30.832,7.442Z",
    transform: "translate(163.599 25.241)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-12",
    "data-name": "Shape",
    d: "M169.285,72.844,0,22.744,45.85,0Z",
    transform: "translate(169.935 47.881)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-13",
    "data-name": "Shape",
    d: "M182.948,50.1,13.664,0,0,36.624Z",
    transform: "translate(156.272 70.625)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-14",
    "data-name": "Shape",
    d: "M25.707,16.06Q18.35,10.181,15.382,5.417A25.722,25.722,0,0,0,10.675.171Q-3.486-.865,1.139,4.363T23.71,21.908q1.839,3.221,2.924,3.875a8.723,8.723,0,0,0,4.23.568,5.645,5.645,0,0,0,3.793.713c.435-.089,10.861-.311,11.073-1.281.354-1.624.437-3.958-2.487-6.232-2.381-1.852-7.8-3.762-8.2-4.407Q33.855,13.236,25.707,16.06Z",
    transform: "translate(192.477 61.73)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-15",
    "data-name": "Shape",
    d: "M38.726,60.69S1.936,58.4.212,50.382c-1.074-5,2.091-19.693,5.931-43.976C6.412,4.707,3.4.961,7.591.14s12.067,2.174,11.97,4.047c-.1,1.92-1.437,3.562-1.48,5.264-.436,17.247,1.712,18.919-.036,27.877,6.576-.9,27.378-.035,27.378-.035L82.432,59.528Z",
    transform: "matrix(-0.848, 0.53, -0.53, -0.848, 261.395, 125.684)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-16",
    "data-name": "Shape",
    d: "M15.9,16.336C12.3,8.993,6.22,2.208,5.038.812.611-1.2.46-.6,0,16.076c-.1,3.633,2.229,10.8,4.052,14.362.963,1.88,14.04-4.843,14.638-11.1C18.783,18.4,16.367,17.3,15.9,16.336Z",
    transform: "translate(189.833 43.022)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-17",
    "data-name": "Shape",
    d: "M31.117,7.273c-.437-.169.02,9.045-6.322,8.225S13.783,1.046,12.565.777Q6.886-.478,4.6.295C1.568,1.317.29,26.1,3.417,42.455S-3.411,68.585,1.278,74C10.171,84.276,16.967,81.376,26.6,75A44.661,44.661,0,0,0,41.817,57.641Q29.649,49.962,34.2,38.185c1.094-2.829,6.859-5.8,6.845-8.944-.03-6.642-5.62-18.19-6.845-20.157C33.268,7.583,32.958,7.986,31.117,7.273Z",
    transform: "translate(159.31 35.128)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-18",
    "data-name": "Shape",
    d: "M8.094,5.433,0,0Q4.51,7.705,5.3,6.017T8.094,5.433Z",
    transform: "translate(186.355 27.944)",
    fill: "#ef6949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-19",
    "data-name": "Shape",
    d: "M3.973,8.752c-2.633-.252-4.985,4.658-3.524,7a4.987,4.987,0,0,0,5.209,2.258c3.328,5.232,9.673,7.652,12.906,7.622,2.755-.026,7.842-9.926,7.527-16.776.677-4.046-2.6-6.2-2.839-8.858-2.1,4.811-9.1,7.2-11.5,8.418-.207.1-2.29,5.9-2.811,6.07C8.181,14.73,8,12.765,7.9,13.1Q6.605,9,3.973,8.752Z",
    transform: "translate(179.432 8.722)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-20",
    "data-name": "Shape",
    d: "M.512,1.467A.674.674,0,0,0,1.173.8.675.675,0,0,0,.666,0a.674.674,0,0,0-.661.67A.675.675,0,0,0,.512,1.467Z",
    transform: "translate(197.967 20.441)",
    fill: "#423565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-21",
    "data-name": "Shape",
    d: "M.512,1.467A.674.674,0,0,0,1.173.8.675.675,0,0,0,.666,0a.674.674,0,0,0-.661.67A.675.675,0,0,0,.512,1.467Z",
    transform: "translate(203.008 20.753)",
    fill: "#423565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-22",
    "data-name": "Shape",
    d: "M1.582,1.182c.891.047,1.626-.179,1.643-.5S2.534.053,1.644.006.017.185,0,.509.692,1.135,1.582,1.182Z",
    transform: "translate(196.145 16.219)",
    fill: "#423565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-23",
    "data-name": "Shape",
    d: "M1.312,1.349c.833.321,1.6.334,1.718.031S2.565.57,1.733.25.131-.085.015.219.479,1.029,1.312,1.349Z",
    transform: "translate(203.956 17.878)",
    fill: "#423565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-24",
    "data-name": "Shape",
    d: "M.007.191A12.458,12.458,0,0,0,1.769,4.243c.174.183.163.3-.037.437A4.288,4.288,0,0,1,.2,5.15a.147.147,0,0,0,.05.29A4.463,4.463,0,0,0,1.9,4.922a.524.524,0,0,0,.082-.882A12.47,12.47,0,0,1,.287.1a.147.147,0,1,0-.28.088Z",
    transform: "translate(200.873 21.426)",
    fill: "#ef6949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-25",
    "data-name": "Shape",
    d: "M.29,2.11C.624.67,1.053.127,1.557.351,2.142.61,2.857,1.6,3.675,3.3a.147.147,0,1,0,.265-.128C3.092,1.407,2.346.379,1.676.081.925-.252.375.445,0,2.043A.147.147,0,1,0,.29,2.11Z",
    transform: "translate(181.731 19.335)",
    fill: "#ef6949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-26",
    "data-name": "Shape",
    d: "M.922.015C.015.465-.25.984.25,1.489a.147.147,0,1,0,.208-.207C.14.96.3.654,1.052.279A.147.147,0,0,0,.922.015Z",
    transform: "translate(183.302 20.557)",
    fill: "#ef6949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-27",
    "data-name": "Shape",
    d: "M1.119,4.033A3.054,3.054,0,0,0,3.768,2.14C4.005,1.11.29-.726.053.3S.408,3.869,1.119,4.033Z",
    transform: "translate(195.131 26.133)",
    fill: "#ef6949"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shape-28",
    "data-name": "Shape",
    cx: 0.588,
    cy: 0.735,
    rx: 0.588,
    ry: 0.735,
    transform: "matrix(-0.848, -0.53, 0.53, -0.848, 182.214, 30.093)",
    fill: "#423565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-29",
    "data-name": "Shape",
    d: "M1.615,0C.723,0,0,.261,0,.586s.724.589,1.617.59S3.233.915,3.232.59,2.508,0,1.615,0Z",
    transform: "matrix(-0.848, -0.53, 0.53, -0.848, 181.126, 29.186)",
    fill: "#423565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-30",
    "data-name": "Shape",
    d: "M.008,8.716a.147.147,0,1,0,.278.094,11.378,11.378,0,0,1,4.83-6.265A13.639,13.639,0,0,1,12.1.294.147.147,0,0,0,12.089,0,13.93,13.93,0,0,0,4.96,2.3,11.671,11.671,0,0,0,.008,8.716Z",
    transform: "translate(197.708 17.975) rotate(-164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-31",
    "data-name": "Shape",
    d: "M17.63.425a.147.147,0,0,0,.053-.29,6.787,6.787,0,0,0-6.348,1.99C8.2,5.26,2.972,7.63.2,6.6a.147.147,0,0,0-.1.276c2.911,1.086,8.239-1.33,11.446-4.538A6.5,6.5,0,0,1,17.63.425Z",
    transform: "translate(160.98 20.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-32",
    "data-name": "Shape",
    d: "M.185.186",
    transform: "translate(311.29 163.259)",
    fill: "none",
    stroke: "#979797",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-33",
    "data-name": "Shape",
    d: "M191.316,12.731,7.282,58.1,0,0Z",
    transform: "translate(139.343 107.249)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-34",
    "data-name": "Shape",
    d: "M259.548,34.978,60.976,0,0,59.522Z",
    transform: "translate(80.846 85.568)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-35",
    "data-name": "Shape",
    d: "M25.4,45.586q-7.358-5.879-10.326-10.642A25.722,25.722,0,0,0,10.37,29.7q4.574-8.089,9.067-17.276C23.931,3.235,17.06-2.022,14.643.732S-3.792,28.661.834,33.889Q5.459,39.117,23.4,51.435q1.839,3.221,2.924,3.875a8.723,8.723,0,0,0,4.23.568,5.645,5.645,0,0,0,3.793.713c.435-.089,10.861-.311,11.073-1.281.354-1.624.437-3.958-2.487-6.232-2.381-1.852-7.8-3.762-8.2-4.407Q33.55,42.762,25.4,45.586Z",
    transform: "translate(143.302 45.526)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-36",
    "data-name": "Shape",
    d: "M2.851,14.961c-.488.954-2.923,2.016-2.85,2.957C.49,24.18,13.449,31.131,14.444,29.268c1.884-3.527,2.437-10.479,4.3-14.289C23.239,5.793,15.911-2.2,13.5.551,12.289,1.926,6.576,7.683,2.851,14.961Z",
    transform: "translate(149.708 35.405)",
    fill: "url(#linear-gradient-6)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl);
export default __webpack_public_path__ + "static/media/girl.41537190f9b962ae01c8a90b3f0326f9.svg";
export { ForwardRef as ReactComponent };